import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const list = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.75rem;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: ${dimensions.tabletMax}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const listLabs = css`
  justify-content: center;

  @media (max-width: ${dimensions.tabletMax}) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: center;
    justify-items: center;
  }
`;

export const listInverseRight = css`
  @media (min-width: ${dimensions.desktop}) {
    justify-content: flex-end;
  }
`;
